export const SLIDE_PADDING = 40
export const HEADER_GAP = 24
export const TRANSLATE_THRESHOLD = 0.1
